module.exports = __webpack_public_path__ + "static/media/logo.190c753d.png";